import React from 'react';
import { useTranslation } from 'react-i18next';
import { CollapseBlock, RawHtml } from '../../../../common/index.jsx';
import { isEmpty } from 'lodash';

export default function WorkplaceDescription({ department }) {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language === 'en';

  if (
    (!isEnglish && isEmpty(department.description_sk?.trim() || '')) ||
    (isEnglish && isEmpty(department.description_en?.trim() || ''))
  ) {
    return null;
  }

  return (
    <CollapseBlock title={t('Popis činnosti')} collapsible>
      <RawHtml>
        {isEnglish ? department.description_en : department.description_sk}
      </RawHtml>
    </CollapseBlock>
  );
}
